import checkRequiredFields from './checkRequiredFields';
import prependProtocol from './prependProtocol';
import ContentConfig from '../../config/ContentConfig';

export interface ContentCallInfoLight {
  contentHost: string;
  contentId: string;
  tenantId: string;
}

export interface ContentCallInfo extends ContentCallInfoLight {
  authToken: string;
  body?: string;
}
type StringUndef = string | undefined;

// exported for unit testing.
export const checkContentCallInfo = (info?: ContentCallInfo): StringUndef => {
  const config = ContentConfig.getInstance();
  const req = ['contentHost', 'contentId', 'tenantId'];
  if (info) {
    if (!config.requestProbeUrls) {
      return 'Not configured to request probe urls';
    }
    return checkRequiredFields(info, req);
  } else {
    return 'No call info provided';
  }
};

export const getContentCallUrl = (info: ContentCallInfoLight): string => {
  const { contentHost, contentId, tenantId } = info;
  const host = prependProtocol(contentHost);
  return `${host}/api/tenant/${tenantId}/content/${contentId}`;
};

export const getContentCall449Url = (info: ContentCallInfo): string => {
  const req = checkContentCallInfo(info);
  if (req) {
    throw new Error(req);
  }
  return getContentCallUrl(info);
};

export const getProbeUrlsUrl = (info: ContentCallInfo): string => {
  return `${getContentCall449Url(info)}/probeUrls`;
};
